import axios from "axios"
import createSpinner from "./lib/create-spinner"
import {Modal, Toast} from 'bootstrap'
import Sortable from "sortablejs"

const minTimeRequiredSelect = document.getElementById('min-time-required')
const maxTimeRequiredSelect = document.getElementById('max-time-required')
const activityForm = document.getElementById('activity-form')
const lessonPlanForm = document.getElementById('lesson-plan-form')
const usedResourceContainer = document.getElementById('used-resource-container')
const resourceSearchForm = document.getElementById('resource-search-form')
const paginationUl = document.getElementById('pagination')
const activityContainer = document.querySelector('.activity-container')
const suppliesContainer = document.getElementById('supplies-container')
const freeFormLessonPlanSectionForm = document.getElementById('free-form-lesson-plan-form')
const freeFormSectionModalElement = document.getElementById('free-form-section-modal')
const freeFormSectionModal = freeFormSectionModalElement && new Modal(freeFormSectionModalElement)

document.querySelectorAll('.btn-edit-free-form-section').forEach(btn => btn.addEventListener('click', editFreeFormSection))

if (freeFormLessonPlanSectionForm) {
    const minTimeElement = freeFormLessonPlanSectionForm.querySelector('input[name="minTimeRequired"]')
    const maxTimeElement = freeFormLessonPlanSectionForm.querySelector('input[name="maxTimeRequired"]')

    const errorMsgDiv = document.getElementById('free-form-error-msg');
    freeFormSectionModalElement.addEventListener('show.bs.modal', () => {
        errorMsgDiv.classList.add('hidden')
    })
    minTimeElement.addEventListener('keyup', evt => {
        maxTimeElement.setAttribute('min', evt.target.value)
    })
    freeFormLessonPlanSectionForm.addEventListener('submit', async (evt) => {
        evt.preventDefault()
        errorMsgDiv.classList.add('hidden')
        try {
            const order = activityContainer.getElementsByClassName('selectable-card').length
            const formData = new FormData(freeFormLessonPlanSectionForm)
            formData.set('order', order)
            const response = await axios.post(freeFormLessonPlanSectionForm.action, formData)
            const div = document.createElement('div')
            div.innerHTML = response.data
            const card = div.firstChild
            card.querySelector('.btn-remove-resource').addEventListener('click', removeResource)
            card.querySelector('.btn-edit-free-form-section').addEventListener('click', editFreeFormSection)
            if (freeFormLessonPlanSectionForm.targetNode) {
                freeFormLessonPlanSectionForm.targetNode.replaceWith(card)
                freeFormLessonPlanSectionForm.targetNode = null
            } else {
                activityContainer.appendChild(card)
            }
            freeFormLessonPlanSectionForm.reset()
            updateLessonPhases()
            updateSupplies()
            updateMinMaxTime()
            freeFormSectionModal.hide()
        } catch {
            errorMsgDiv.classList.remove('hidden')
        }
    })
}

if (activityContainer) {
    Sortable.create(activityContainer, {
        onEnd: updateLessonPhases
    })
}

function getCurrentResourceIds() {
    const ids = []
    Array.from(usedResourceContainer.getElementsByClassName('selectable-card')).forEach(card => {
        ids.push(card.dataset.resourceId)
    })
    return ids
}

function updateSupplies() {
    if (!suppliesContainer) {
        return
    }

    const added = [];
    const ul = document.getElementById('supplies-ul')
    while (ul.hasChildNodes()) {
        ul.removeChild(ul.firstChild)
    }
    usedResourceContainer.querySelectorAll('.selectable-card').forEach(card => {
        JSON.parse(card.dataset.supplies).forEach(supply => {
            if (!added.includes(supply)) {
                added.push(supply)
                const li = document.createElement('li');
                li.innerText = supply
                ul.appendChild(li)
            }
        })
    })
    suppliesContainer.classList.toggle('hidden', added.length === 0)
}

function updateLessonPhases() {
    if (!activityContainer) {
        return
    }
    let order = 0;

    activityContainer.querySelectorAll('.selectable-card').forEach(card => {
        card.querySelectorAll('input[type="hidden"]').forEach(input => {
            const currentName = input.name
            input.name = currentName.replace(/\[(\d+)]/, `[${order}]`)
            if (input.name.match(/\[order]$/)) {
                input.value = order
            }
        })

        card.querySelectorAll('.btn-free-form-section').forEach(btn => {
            btn.id = btn.id.replace(/-(\d+)$/, `-${order}`)
        })
        order++
    })
}

function addResource(event) {
    const card = event.target.closest('.selectable-card')
    card.querySelectorAll('button').forEach(button => button.classList.toggle('hidden'))
    card.remove()
    usedResourceContainer.appendChild(card)
    updateMinMaxTime()
    refreshAvailableResources()
    updateSupplies()
    updateLessonPhases()
}

function removeResource(event) {
    const card = event.target.closest('.selectable-card')
    card.remove()
    updateMinMaxTime()
    refreshAvailableResources()
    updateSupplies()
    updateLessonPhases()
}

function editFreeFormSection(evt) {
    const card = evt.target.closest('.free-form-section-card')
    const supplies = Array.from(card.querySelectorAll('.supplies-input')).map(input => input.value)
    card.querySelectorAll('input[type="hidden"]').forEach(input => {
        const formElementName = input.dataset.formElementName
        if (!formElementName) {
            return
        }
        const inputTag = input.dataset.formElementInputTag
        const formElement = freeFormLessonPlanSectionForm.querySelector(`${inputTag}[name="${formElementName}"]`)
        formElement.value = input.value
    })

    freeFormLessonPlanSectionForm.querySelectorAll('input[name="supplies[]"]').forEach(checkbox => checkbox.checked = supplies.includes(checkbox.value))
    freeFormLessonPlanSectionForm.targetNode = card
    freeFormSectionModal.show()
}

function refreshAvailableResources() {
    const uri = new URL(resourceSearchForm.action)
    const availableResourceContainer = document.getElementById('available-resource-container')
    const pageNumber = resourceSearchForm.dataset.pageNumber
    getCurrentResourceIds().forEach(id => {
        uri.searchParams.append('excludeResourceIds[]', id)
    })
    if (pageNumber) {
        uri.searchParams.append('page', pageNumber)
    }
    Object.values(resourceSearchForm).forEach(field => {
        if (field.value) {
            uri.searchParams.append(field.name, field.value)
        }
    })
    availableResourceContainer.innerHTML = ''
    availableResourceContainer.appendChild(createSpinner())
    try {
        axios.get(uri.toString())
            .then(response => {
                const resourceType = response.data.resourceType
                const resources = response.data.resources
                const cardTemplate = document.getElementById('card-template-container').children[0]
                const paginationData = response.data.paginationData
                const formErrors = response.data.formErrors

                availableResourceContainer.innerHTML = ''
                resources.forEach(resource => {
                    const card = cardTemplate.cloneNode(true)
                    card.dataset.resourceId = resource.id
                    card.dataset.status = resource.status
                    card.querySelector('.card-header').innerText = resource.title
                    card.querySelector('.card-title').innerText = resource.description
                    card.querySelector('.resource-id').value = resource.id
                    if (resource.isPurchased) {
                        card.querySelectorAll('.content-creator-li').forEach(li => li.classList.remove('hidden'))
                        const contentCreatorLink = card.querySelector('.content-creator-link')
                        contentCreatorLink.setAttribute('href', resource.contentCreatorUrl)
                        contentCreatorLink.innerText = resource.createdBy
                        card.querySelector('.purchased-at-span').innerText = resource.purchaseDate
                    }
                    if (resourceType === 'material') {
                        card.querySelector('.material-type').innerText = resource.materialType
                        card.querySelector('i').classList.add(`fa-file-${resource.fileType}`)
                        card.querySelector('.file-size').innerText = resource.fileSize
                    } else {
                        card.querySelector('.lesson-phase').innerText = resource.lessonPhase
                        card.querySelector('.time-required').innerText = resource.timeRange
                        card.querySelector('.age-range').innerText = resource.ageRange
                        card.querySelector('.skill-level').innerText = resource.skillLevel
                        card.dataset.minTime = resource.minTime
                        card.dataset.maxTime = resource.maxTime
                        card.dataset.supplies = resource.supplies
                    }
                    const selectResourceBtn = card.querySelector('.btn-selectable-resource')
                    const removeResourceBtn = card.querySelector('.btn-remove-resource')
                    selectResourceBtn.addEventListener('click', addResource)
                    selectResourceBtn.id = `use-resource-${resource.id}`
                    removeResourceBtn.addEventListener('click', removeResource)
                    removeResourceBtn.id = `remove-resource-${resource.id}`
                    availableResourceContainer.appendChild(card)
                })

                Array.from(resourceSearchForm.getElementsByTagName('ul')).map(el => el.remove())
                if (Object.keys(formErrors).length > 0) {
                    for (const [inputName, errorMessages] of Object.entries(formErrors)) {
                        const inputContainer = resourceSearchForm.querySelector(`[name="${inputName}"]`).parentElement
                        const errorUl = document.createElement('ul')

                        errorUl.classList.add('list-unstyled', 'text-danger')

                        for (const [, errorMessage] of Object.entries(errorMessages)) {
                            const li = document.createElement('li')
                            li.innerText = errorMessage
                            errorUl.append(li)
                        }

                        inputContainer.append(errorUl)
                    }
                }

                if (paginationData.length <= 1) {
                    paginationUl.classList.add('hidden')
                    return
                }

                paginationUl.classList.remove('hidden')
                paginationUl.innerHTML = ''
                Array.from(paginationData).forEach(paginationItem => {
                    const li = document.createElement('li')

                    li.classList.add('page-item')
                    if (paginationItem.isActive) {
                        li.classList.add('active')
                        const span = document.createElement('span')
                        span.classList.add('page-link', 'active')
                        span.innerText = paginationItem.label
                        li.append(span)
                    } else {
                        const span = document.createElement('span')
                        span.classList.add('page-link')
                        span.innerText = paginationItem.label
                        span.dataset.pageNumber = paginationItem.pageNumber
                        span.style.cursor = 'pointer'
                        span.addEventListener('click', (evt) => {
                            resourceSearchForm.dataset.pageNumber = evt.target.dataset.pageNumber
                            refreshAvailableResources()
                        })
                        li.append(span)
                    }

                    paginationUl.append(li)
                })
            })
    } catch {
    }
}

function updateProgressBarClass(progressBar, percentComplete) {
    if (percentComplete < 10) {
        progressBar.classList.add('bg-info')
        progressBar.classList.remove('bg-danger', 'bg-primary', 'bg-warning', 'bg-success')
    } else if (percentComplete < 75) {
        progressBar.classList.add('bg-warning')
        progressBar.classList.remove('bg-danger', 'bg-primary', 'bg-info', 'bg-success')
    } else if (percentComplete <= 100) {
        progressBar.classList.add('bg-success')
        progressBar.classList.remove('bg-danger', 'bg-primary', 'bg-info', 'bg-warning')
    } else {
        progressBar.classList.add('bg-danger')
        progressBar.classList.remove('bg-success', 'bg-primary', 'bg-info', 'bg-warning')
    }
}

function updateMinMaxTime() {
    if (!usedResourceContainer?.classList.contains('activity-container')) {
        return
    }
    let minTime = 0
    let maxTime = 0
    let minTimeRequired = parseInt(minTimeRequiredSelect.value || '0', 10)
    let maxTimeRequired = parseInt(maxTimeRequiredSelect.value || '0', 10)
    Array.from(usedResourceContainer.getElementsByClassName('selectable-card')).forEach(card => {
        minTime += parseInt(card.dataset.minTime, 10)
        maxTime += parseInt(card.dataset.maxTime, 10)
    })

    if (minTimeRequired > 0) {
        let minComplete = Math.round(((minTime / minTimeRequired) * 100))
        let progressBar = document.getElementById('min-progress')
        progressBar.style.width = minComplete + '%'
        updateProgressBarClass(progressBar, minComplete)
        document.getElementById('min-complete').innerText = minComplete + '%'
    }
    if (maxTimeRequired > 0) {
        let maxComplete = Math.round(((maxTime / maxTimeRequired) * 100))
        let progressBar = document.getElementById('max-progress')
        updateProgressBarClass(progressBar, maxComplete)
        progressBar.style.width = maxComplete + '%'
        document.getElementById('max-complete').innerText = maxComplete + '%'
    }
    if (minTimeRequired > 0 || maxTimeRequired > 0) {
        document.getElementById('add-activity-message').classList.add('hidden')
    }
}

function hasInvalidResources() {
    let result = false
    Array.from(usedResourceContainer.getElementsByClassName('selectable-card')).forEach(card => {
        const status = card.dataset.status
        if (status === 'blocked') {
            result = true
        }
    })

    return result;
}

function preventSubmittingWithInvalidResources(event) {
    if (hasInvalidResources()) {
        event.preventDefault()
        const toast = new Toast(document.getElementById('cannot-save-toast'))
        toast.show()
    }
}

Array.from(document.getElementsByClassName('time-input')).forEach(input => {
    input.addEventListener('input', () => {
        updateMinMaxTime()
    })
})

updateMinMaxTime()
updateSupplies()

Array.from(document.getElementsByClassName('btn-selectable-resource')).forEach(function (button) {
    button.addEventListener('click', addResource)
})
Array.from(document.getElementsByClassName('btn-remove-resource')).forEach(function (button) {
    button.addEventListener('click', removeResource)
})
activityForm?.addEventListener('submit', preventSubmittingWithInvalidResources)

lessonPlanForm?.addEventListener('submit', (evt) => {
    const numActivities = usedResourceContainer.getElementsByClassName('selectable-card').length
    if (numActivities === 0) {
        document.getElementById('add-activity-message').classList.remove('hidden')
        evt.preventDefault()
    }
    preventSubmittingWithInvalidResources(evt)
})

if (resourceSearchForm) {
    resourceSearchForm.addEventListener('submit', (evt) => {
        evt.preventDefault()
        resourceSearchForm.dataset.pageNumber = '1'
        refreshAvailableResources()
    })
    refreshAvailableResources()
}
